






import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
})
export default class ImgFullscreen extends Vue {
  public expanded = false;
  public cloned: any;

  closeImage() {
    this.expanded = false;
  }

  removeClonedImage() {
    this.cloned.remove();
    this.cloned = null;
  }

  @Watch('expanded')
  onExpanded(newVal: boolean, _oldVal: boolean) {
    this.$nextTick(() => {
      // Run this if when we're expanding the image
      if (newVal) {
        // Clone the entire expandable-image element
        this.cloned = this.$el.cloneNode(true);
        // Call closeImage when we click on clonned image or when we scroll the mouse wheel
        this.cloned.addEventListener('click', this.closeImage);
        this.cloned.addEventListener('wheel', this.closeImage);
        // Add the cloned element into <body>
        document.body.appendChild(this.cloned);

        setTimeout(() => {
          // Show the cloned element
          this.cloned.style.opacity = 1;
        }, 0);
      } else {
        // This section will run when the image is closing
        // Hide the expanded image
        this.cloned.style.opacity = 0;

        this.cloned.addEventListener('transitionend', this.removeClonedImage);
      }
    });
  }
}
